export const DEFAULT_LATITUDE = -27.681927396540104;
export const DEFAULT_LONGITUDE = 152.9043310817896;
export const DEFAULT_ZOOM_LEVEL = 17;
